import { List, Typography, Divider } from "@mui/material";
import SourcingListItem from "models/sourcings/SourcingListItem";

const CommitteeList = ({ committeeSourcingList, onClick }) => {
  return (
    <List sx={{ p: 0 }}>
      {Object.entries(committeeSourcingList).map(([key, sourcings], index) => {
        return (
          <div key={`list2-${index}`}>
            <Typography variant="h5" sx={{ mt: 3 }}>
              {key}
            </Typography>
            <Divider />
            <List key={`list-${key}`} variant="boxed">
              {sourcings.map((sourcing, index) => {
                return (
                  <SourcingListItem
                    key={`${sourcing.id}-${index}`}
                    sourcing={sourcing}
                    onClick={onClick}
                  />
                );
              })}
            </List>
          </div>
        );
      })}
    </List>
  );
};

export default CommitteeList;
